import type UserDocumentTemplateConfigurationModel from 'garaje/models/user-document-template-configuration';
import type VisitorDocumentModel from 'garaje/models/visitor-document';

/**
 * Returns true when every active config on a document-upload-page has a
 * matching visitor document, or when there are no active configs at all.
 *
 * Configs — not templates — are the source of truth because they carry
 * per-flow overrides (reUploadConfig, optional, etc.).
 *
 * @param activeConfigs - The active UserDocumentTemplateConfiguration records
 *   for the flow's document-upload-page.
 * @param visitorDocuments - The visitor's uploaded documents for this entry/invite.
 */
export function allRequiredDocumentsUploaded(
  activeConfigs: UserDocumentTemplateConfigurationModel[],
  visitorDocuments: VisitorDocumentModel[],
): boolean {
  if (activeConfigs.length === 0) return true;

  const uploadedTemplateIds = new Set(
    visitorDocuments.map((d) => d.belongsTo('userDocumentTemplate').id()).filter((id): id is string => id !== null),
  );

  return activeConfigs.every((c) => {
    const templateId = c.belongsTo('userDocumentTemplate').id();
    if (!templateId) return true;
    return uploadedTemplateIds.has(templateId);
  });
}
